export function isDeepEqual<T extends string | number | Object | Array<T>>(
  a: T,
  b: T,
): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;

  if (typeof a === "number" && typeof b === "number") {
    return (
      Math.abs(a - b) <= Number.EPSILON * Math.max(1, Math.abs(a), Math.abs(b)) // 1 ULP relative tolerance for floating point arithmetic imprecision (e.g. 0.1 + 0.2 vs 0.3)
    );
  }

  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((val, index) => isDeepEqual(val, b[index]));
  }

  if (typeof a === "object" && typeof b === "object") {
    const keysA = Object.keys(a).filter((key) => a[key] !== undefined);
    const keysB = Object.keys(b).filter((key) => b[key] !== undefined);

    if (keysA.length !== keysB.length) return false;
    return keysA.every((key) => isDeepEqual(a[key], b[key]));
  }
  return false;
}
